import styles from './CompleteStaffPage.module.css';

import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { IoAddCircleOutline } from 'react-icons/io5';

import IconAndName from '../../components/IconAndName/IconAndName';
import CopyRight from '../../components/CopyRight/CopyRight';
import ThreeDotMenu from '../../components/ThreeDotMenu/ThreeDotMenu';

import { openModal } from '../../redux/slices/modalSlice';
import ProfilePage from '../StaffProfilePages/ProfilePage/ProfilePage';
import PersonalFilesPage from '../StaffProfilePages/PersonalFilesPage/PersonalFilesPage';
import AttendancePage from '../StaffProfilePages/Attendance/AttendancePage';
import LeavesPage from '../StaffProfilePages/LeavesPage/LeavesPage';
import FormsPage from '../StaffProfilePages/FormsPage/FormsPage';
import NotesPage from '../StaffProfilePages/NotesPage/NotesPage';

const CompleteStaffPage = () => {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState('Profile');

  const tab = [
    { label: 'Profile', content: <ProfilePage /> },
    { label: 'Personal Files', content: <PersonalFilesPage /> },
    { label: 'Attendance', content: <AttendancePage /> },
    { label: 'Leaves', content: <LeavesPage /> },
    { label: 'Forms', content: <FormsPage /> },
    { label: 'Notes', content: <NotesPage /> },
  ];

  const logsData = [
    {
      action: 'TEACHER ADDED',
      timestamp: '25 May 2025, 8:49 AM',
      name: '',
      updatedBy: 'Narasimha',
    },
    {
      action: 'TEACHER ADDED',
      timestamp: '25 May 2025, 8:49 AM',
      name: '',
      updatedBy: 'Narasimha',
    },
    {
      action: 'TEACHER ADDED',
      timestamp: '25 May 2025, 8:49 AM',
      name: '',
      updatedBy: 'Narasimha',
    },
  ];

  const actionsMenu = [
    {
      label: 'Change Logs',
      onClick: () =>
        dispatch(
          openModal({
            type: 'changeLogs',
            data: logsData,
          })
        ),
    },
    { label: 'Delete Staff', onClick: () => dispatch(openModal('delete')) },
  ];

  return (
    <>
      <div className={styles.background}>
        {activeTab === 'Notes' && (
          <div className={styles.buttonRow}>
            <IconAndName
              icon={<IoAddCircleOutline />}
              title="Add Note"
              bgColor="Primary_Color"
              onClick={() => dispatch(openModal('addNote'))}
            />
          </div>
        )}

        {/* Main tab layout */}
        <div className={styles.StudentSection}>
          <div className={styles.maincontainer}>
            <div className={styles.container}>
              {tab.map((item, index) => (
                <div
                  key={index}
                  className={`${styles.tabOptions} ${
                    activeTab === item.label && styles.ActivetabOption
                  }`}
                  onClick={() => setActiveTab(item.label)}
                >
                  {item.label}
                </div>
              ))}
            </div>

            <div className={styles.buttonRow}>
              <ThreeDotMenu options={actionsMenu} />
            </div>
          </div>

          <div className={styles.tabContentContainer}>
            {tab.find((item) => item.label === activeTab)?.content}
          </div>
        </div>
      </div>

      <div>
        <CopyRight />
      </div>
    </>
  );
};

export default CompleteStaffPage;
